export default __webpack_public_path__ + "static/media/project_1.fe46c624.png";